var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-not-working-label d-flex align-start rounded-sm",
      attrs: { "data-qa": "lpu-not-working-alert" },
    },
    [
      _c("span", {
        staticClass: "lpu-not-working-label__icon ui-icon-circle-warning",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "lpu-not-working-label__text text-body-2 text--text py-2 pl-2 pr-4",
        },
        [_vm._v("\n    " + _vm._s(_vm.lpuWorkingText) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }